import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import MediaParallax from '@/components/base/media-parallax'
import Section from '@/components/base/section'

import { cn } from '@/lib/utils'
import { WPMedia } from '@/types'

export type SingleMediaProps = HTMLAttributes<HTMLDivElement> & Partial<{ media: WPMedia }>

const SingleMedia = ({ media, ...props }: SingleMediaProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid>
          {media ? (
            <MediaParallax
              className={cn(
                'relative col-span-2 md:col-span-6 lg:col-span-12',
                'aspect-[380/340] overflow-hidden md:aspect-video'
              )}
            >
              <span className="flex size-full">
                <Media className="object-cover" {...media} />
              </span>
            </MediaParallax>
          ) : null}
        </Grid>
      </Container>
    </Section>
  )
}

export default SingleMedia
